export const Dropdown = (function () {
	'use strict';

	let $dropdowns;

	function init() {
		$dropdowns = $('.dropdown');
		if(!$dropdowns.length > 0) return null;
		events();
	}

	function events() {
		$dropdowns.each( function(){
			let $dropdown = $(this);
			let $button = $dropdown.find('.dropdown__button');
			let $results = $dropdown.find('.dropdown__results');
			let $links = $dropdown.find('.dropdown__links');
			
			// console.log('here');
			$button.on('click', function(){
				// console.log('clicked');
				if($dropdown.hasClass('dropdown--active')) {
					$dropdown.removeClass('dropdown--active');
					$results.fadeOut();
					return;
				}
				$dropdown.addClass('dropdown--active');
				$results.fadeIn();
			})
	
			$links.find('li').each(function(){
				let $this = $(this);
				let $link = $this.find('a');
	
				$link.on('click', function(){
					// console.log('link clicked');
					let id = $(this).attr('href');
					$results.hide();
					$dropdown.removeClass('dropdown--active');
					$('.resources-mobile').parent().removeClass('resources-mobile--active');
					$(id).parent().addClass('resources-mobile--active');
				})
			});
	
		});
	}

	return {
		init: init,
	};
})();
